import { getFromLocalStorage, setInLocalStorage } from '@/utils/local-storage';

export default {
    state() {
        return {
            widgetOpenedList: [], // opened widgets for preventing double opening, if nothing is opened list is empty
            widgetMetaList: [], // full list with component instance && visibleIndex
            cardFormData: {},
        };
    },
    mutations: {
        setMetaList(state, { metaList }) {
            state.widgetMetaList = metaList;
        },
        setCardData(state, {cardData}){
            state.cardFormData = cardData;
        },
        addOpenedWidget(state, { item }) {
            state.widgetOpenedList.push(item);
        },
        updateOpenedWidgetVisibility(state, { index, value }) {
            state.widgetOpenedList[index].visible = value;
        },
        deleteOpenedWidget(state, id) {
            state.widgetOpenedList = state.widgetOpenedList.filter(item => item.id !== id);
        },
        clearOpenedWidget(state) {
            state.widgetOpenedList = [];
        },
    },
    actions: {
        // meta list
        createWidgetMetaList({ commit }, metaList) {
            const newMetaList = metaList.map((item, index) => {
                item.visibleIndex = index;
                return item;
            });
            commit('setMetaList', { metaList: newMetaList });
        },
        addCardData({commit},cardData){
            commit('setCardData',{cardData: cardData})
        },
        async initVisibleIndexFromLocalStorage({ state, commit }, { localStorageKey }) {
            const visibleIndexMetaList = getFromLocalStorage(localStorageKey);

            const newMetaList = state.widgetMetaList.map((item, index) => {
                if (visibleIndexMetaList) item.visibleIndex = visibleIndexMetaList[index]?.visibleIndex;
                else item.visibleIndex = index;
                return item;
            });
            commit('setMetaList', { metaList: newMetaList });

            setInLocalStorage(localStorageKey, this.getters.getVisibleIndexList());
        },
        reorderMetaWidgetPositions({ state, commit }, { from, to, localStorageKey }) {
            const newMetaList = state.widgetMetaList.map(item => {
                const index = item.visibleIndex;

                if (index === from) {
                    item.visibleIndex = null;
                }
                if (from < to) {
                    if (index > from && index <= to) item.visibleIndex--;
                } else if (index >= to && index < from) item.visibleIndex++;
                return item;
            });

            newMetaList.find(item => item.visibleIndex === null).visibleIndex = to;
            commit('setMetaList', { metaList: newMetaList });

            setInLocalStorage(localStorageKey, this.getters.getVisibleIndexList());
        },

        // opened list
        addOpenedWidget({ state, commit }, { value }) {
            const widgetMatch = state.widgetMetaList.find(item => item.name === value);
            const duplicateIndex = state.widgetOpenedList.findIndex(item => item.id === widgetMatch.id);

            if (duplicateIndex === -1) {
                widgetMatch.visible = true;
                commit('addOpenedWidget', { item: widgetMatch });
            } else {
                const { visible } = state.widgetOpenedList.find(clicked => clicked.id === widgetMatch.id);
                if (visible) {
                    return widgetMatch;
                } else commit('updateOpenedWidgetVisibility', { index: duplicateIndex, value: true });
            }
            return null;
        },

        // popup
        hidePopupWidgetWindow({ commit }, { index }) {
            commit('updateOpenedWidgetVisibility', { index, value: false });
        },
    },
    getters: {
        getOpenedWidgetByName: state => name => state.widgetOpenedList.findIndex(clicked => clicked.name === name),
        getSortedDisplayList: state => () => {
            const simplifiedMenuList = state.widgetMetaList.map(widget => {
                const { id, name, description, icon, visibleIndex } = widget;
                return { id, name, description, icon, visibleIndex };
            });

            return simplifiedMenuList.sort((a, b) => {
                if (a.visibleIndex < b.visibleIndex) return -1;
                if (a.visibleIndex > b.visibleIndex) return 1;
                return 0;
            });
        },
        getVisibleIndexList: state => () =>
            state.widgetMetaList.map(item => {
                return { visibleIndex: item.visibleIndex };
            }),
    },
};
